module.exports = __webpack_public_path__ + "img/bukowianka-logo.ef7fa97f.png";